import {Component, Input} from '@angular/core';
import {BrBergWetterbericht} from '../../../../../../../model/vorhersagen/br-wetterbericht';

@Component({
  selector: 'app-br-bergwetter-bericht',
  templateUrl: './br-bergwetter-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class BrBergwetterBerichtComponent {
  @Input() bergWetterbericht: BrBergWetterbericht;
}
